// extracted by mini-css-extract-plugin
export var dropdown = "_t3-0";
export var imageWrapper = "_t3-3";
export var itemNameContainer = "_t3-1";
export var productImage = "_t3-2";
export var spinnerWrapper = "_t3-4";